// extracted by mini-css-extract-plugin
export default {"container":"ConfigDetails_container__L+S4o","row":"ConfigDetails_row__5zM+j"};